import rfpStorelocatorCurrentLocation from './components/widget/current-location/rfp-storelocator-currentLocation.vue';
import rfpStorelocatorLocationsearch from './components/widget/location-search/rfp-storelocator-locationsearch.vue';
import rfpStorelocatorStorelist from './components/widget/store-list/rfp-storelocator-storelist.vue';
import rfpStorelocatorGoogleMap from './components/widget/google-map/rfp-storelocator-google-map.vue';
import rfpStorelocatorPromotionBanner from './components/widget/promotion/promotion-banner.vue';
import rfpStorelocatorPromotionList from './components/widget/promotion/promotion-list.vue';
import rfpStorelocatorLoading from './components/widget/loading/rfp-storelocator-loading.vue';
import rfpStorelocatorPrivacyText from './components/widget/privacy-text/rfp-storelocator-privacy-text.vue';
import rfpStorelocatorSocialLinks from './components/widget/social-links/rfp-storelocator-social-links.vue';
import rfpStorelocatorMapPopup from './components/widget/map-popup/rfp-storelocator-map-popup.vue';
import rfpStorelocatorStoreAttributes from './components/widget/store-attributes/rfp-storelocator-store-attributes.vue';
import rfpStorelocatorSummary from './components/widget/summary/rfp-storelocator-summary.vue';

import './styles/widget/entry.scss';

export default {
  install(app) {
    const components = [
      rfpStorelocatorCurrentLocation,
      rfpStorelocatorLocationsearch,
      rfpStorelocatorStorelist,
      rfpStorelocatorGoogleMap,
      rfpStorelocatorPromotionBanner,
      rfpStorelocatorPromotionList,
      rfpStorelocatorLoading,
      rfpStorelocatorPrivacyText,
      rfpStorelocatorSocialLinks,
      rfpStorelocatorMapPopup,
      rfpStorelocatorStoreAttributes,
      rfpStorelocatorSummary,
    ];

    components.forEach((c) => app.component(c.name, c));
  },
};
